var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// /home/trafficplatform/trafficplatform-dash/node_modules/core-js/modules/_has.js
// module id = 24
// module chunks = 0